module.exports = __webpack_public_path__ + "static/media/img_logo.cc8ca111.jpg";